// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3hxHo","title":"Images45_title__1yNO5","images":"Images45_images__1bK0V"};